import { render, staticRenderFns } from "./RegistrationApprovalActions.vue?vue&type=template&id=0412534c"
import script from "./RegistrationApprovalActions.vue?vue&type=script&lang=js"
export * from "./RegistrationApprovalActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports